import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: "auth",
    initialState: { isAuthenticated: false, isSessionLost: false, authenticatedUser: null },
    reducers: {
        onLogin: (state, action) => {
            const authenticatedUser = action.payload;

            state.isAuthenticated = true;
            state.isSessionLost = false;
            state.authenticatedUser = authenticatedUser;
        },
        onLogout: (state) => {
            state.isAuthenticated = false;
            state.authenticatedUser = null;
        },
        onSessionLost: (state) => {
            state.isSessionLost = true;
            state.authenticatedUser = null;
        }
    },
});

export const { onLogin, onLogout, onSessionLost } = authSlice.actions;
export default authSlice.reducer;
